import type { Plugin, ObjectDirective } from 'vue';

const focusOnInsert: ObjectDirective = {
  mounted: (el): void => {
    setTimeout(() => {
      el.focus();

      if (el instanceof HTMLInputElement) {
        el.select();
      }
    });
  },
};

export const focusOnInsertPlugin: Plugin = {
  install(vue) {
    vue.directive('focusOnInsert', focusOnInsert);
  },
};
